import { useIntl } from 'react-intl'
import styled from 'styled-components'

// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { CircleCheckIcon } from '@10xLabs/react-web/components/Icons/CircleCheck'
// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { FilledCircleCloseIcon } from '@10xLabs/react-web/components/Icons/FilledCircleClose'
import { DRAWER_STATUS } from './constants'
import { drawerStatusMessages } from './messages'

const isOpen = (status: TSFixMe): TSFixMe => {
  return status === DRAWER_STATUS.OPEN
}

const Container = styled.div<TSFixMe>`
  display: inline-flex;
  align-items: center;
  border-radius: 5px;
  padding: 10px 20px 10px 10px;
  background-color: ${({ status }): TSFixMe => (isOpen(status) ? 'rgba(255, 183, 77, 0.13)' : '#ecebf4')};
  color: ${({ status }): TSFixMe => (isOpen(status) ? '#ef6c00' : '#5d5c70')};

  svg {
    fill: ${({ status }): TSFixMe => (isOpen(status) ? '#ef6c00' : '#5d5c70')};
    margin-right: 7px;
  }
`

export const DrawerStatus = ({ status }: TSFixMe): TSFixMe => {
  const intl = useIntl()

  return (
    <Container status={status}>
      {isOpen(status) ? <CircleCheckIcon /> : <FilledCircleCloseIcon />}

      {drawerStatusMessages[status] ? intl.formatMessage(drawerStatusMessages[status]) : status}
    </Container>
  )
}
